import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Agent } from '@/types/agent/agent';

/**
 * Hook to fetch specific genies for branding examples showcase
 */
export const useBrandingExamples = () => {
  return useQuery({
    queryKey: ['branding-examples'],
    queryFn: async () => {
      const exampleNames = ['App Dev', 'Tesla-genie'];

      const { data, error } = await supabase
        .from('agents')
        .select('id, name, branding')
        .in('name', exampleNames)
        .limit(3);

      if (error) {
        console.error('Error fetching branding examples:', error);
        return [];
      }

      return (data || []) as Pick<Agent, 'id' | 'name' | 'branding'>[];
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    refetchOnWindowFocus: false,
  });
};
